import { caseInsensitiveCompare } from './StringUtil';
export function getSetting(settings, key) {
    var _a;
    return (_a = settings === null || settings === void 0 ? void 0 : settings.find(setting => caseInsensitiveCompare(setting.key, key))) === null || _a === void 0 ? void 0 : _a.value;
}
